export const TABLE_DATA = {
  heading: "Why OneMind OEM Converged Architecture Stands Apart ",
  desc: "Industries like manufacturing, healthcare, telecom, and finance trust OneMind's OEM Converged Architecture to modernize operations while maintaining performance, compliance, and security at scale. ",
  headers: {
    capability: "Capability",
    onemind: "OneMind OEM Converged",
    traditional: "Traditional OEM IT",
    singleVendor: "Single-Vendor OEM Stack",
    diyMultiCloud: "DIY Multi-Cloud Setup",
  },
  data: [
    {
      capability: "Unified Infrastructure",
      onemind: "Integrated compute, storage, networking & software with minimal overhead",
      traditional: "Siloed systems, complex to manage",
      singleVendor: "Limited flexibility, locked to vendor stack",
      diyMultiCloud: "High complexity, manual integration",
    },
    {
      capability: "Hybrid & Multi-Cloud Ready",
      onemind: "Seamless integration with  Zadara, OpenStack,  and private/public clouds",
      traditional: "On-prem locked",
      singleVendor: "Tied to vendor’s cloud or hardware",
      diyMultiCloud: "Possible, but effort-intensive",
    },
    {
      capability: "Edge & CPwE Compatibility",
      onemind:
        "Native support for Edge Computing and Converged Plantwide Ethernet (CPwE)",
      traditional: "No native edge capabilities",
      singleVendor: "Limited edge support in roadmap",
      diyMultiCloud: "Requires custom edge solutions",
    },
    {
      capability: "Pre-Validated Multi-Vendor Stack",
      onemind:
        "Works across Dell, Cisco, PureStorage, NetApp, and others — pre-tested for OEM use cases",
      traditional: "Requires case-by-case validation",
      singleVendor: "Vendor-specific, minimal cross-vendor support",
      diyMultiCloud: "Risk of misconfigurations",
    },
    {
      capability: "Security & Compliance",
      onemind:
        "Built-in Zero Trust, encrypted storage, role-based access, and policy-based control at every layer",
      traditional: "Patchwork security, prone to misalignment",
      singleVendor: "Proprietary solutions, less transparent",
      diyMultiCloud: "Requires assembling multiple third-party tools",
    },
    {
      capability: "Operational Efficiency",
      onemind:
        "Centralized management, streamlined hybrid deployments, and intelligent scaling with automation",
      traditional: "Manual provisioning and scaling",
      singleVendor: "Basic automation, often upsold",
      diyMultiCloud: "Scripting-heavy, error-prone",
    },
    {
      capability: "Deployment Model",
      onemind: "Flexible: Managed, Unmanaged, or Co-managed, with enterprise-ready SLAs",
      traditional: "Internal IT team heavy lifting",
      singleVendor: "Premium services at added cost",
      diyMultiCloud: "You own all maintenance and updates",
    },
    {
      capability: "Support for Modern Workloads",
      onemind:
        "VDI on Private Cloud, container clusters, and optimized I/O for AI, analytics & IoT",
      traditional: "Hardware-bound limitations",
      singleVendor: "Slow modernization, limited VDI/container support",
      diyMultiCloud: "Uncertain compatibility and performance tuning",
    },
    {
      capability: "Time to Value",
      onemind: "Rapid deployment through pre-integrated platforms and automation",
      traditional: "Multi-quarter deployments",
      singleVendor: "Moderate (vendor pace)",
      diyMultiCloud: "High effort and time",
    },
  ],
};
